import { gql } from '@apollo/client';
import client from '~/apollo/client'; // Centralized Apollo Client
import { AuthRequest, AuthResponse } from '~/apollo/graphql';

const AUTHENTICATE_MUTATION = gql`
  mutation Authenticate($input: AuthRequest!) {
    authenticate(input: $input) {
      token
      user {
        id
        firstName
        lastName
        email
        avatarURL
      }
    }
  }
`;

export const authenticate = async (
  input: AuthRequest
): Promise<AuthResponse> => {
  const result = await client.mutate<
    {
      authenticate: AuthResponse;
    },
    { input: AuthRequest }
  >({
    mutation: AUTHENTICATE_MUTATION,
    variables: { input },
  });

  if (!result.data) {
    throw new Error('No data returned from authenticate mutation');
  }

  return result.data?.authenticate;
};
